import { ImagePreloadConfig } from "~/types/PreloadConfig";

export const getDefaultImagePreloadConfig = (id: string): ImagePreloadConfig => ({
  type: "image",
  id,
  flipY: true,
});
